import { useLazyQuery } from "@apollo/react-hooks";
import { Card, Empty, Progress } from "antd";
import moment from "moment-timezone";
import React, { Fragment, useEffect, useState } from "react";
import { Loader } from "../../../Components/Loader";
import { CustIcon } from "../../../Components/Svgs/Svgs";
import { UserAvatar } from "../../../Components/UserAvatar";
import { GET_TOP_3_PERFORMERS } from "../../../Graphql/queries";
import Empty_TopPerformer from "../../../Assets/Images/Empty/EmptyTopPerformerEmptyVector.svg";
import "./TopPerformer.less";
const { REACT_APP_ASSETS_URL } = process.env;

export const TopPerformer = ({ userTimeZone, userTypeId }) => {
  const [topPerformerList, setTopPerformerList] = useState([]);
  const [GET_TOP_3_PERFORMERS_QUERY, { data, loading }] =
    useLazyQuery(GET_TOP_3_PERFORMERS);

  useEffect(() => {
    if (userTimeZone) {
      GET_TOP_3_PERFORMERS_QUERY({
        variables: {
          user_id: localStorage.getItem("user_id"),
          month: moment.tz(userTimeZone).get("month"),
        },
      });
    }
  }, [userTimeZone]);

  useEffect(() => {
    if (data) {
      const filteredArr = data.user_reporting_view.reduce((acc, current) => {
        const x = acc.find(
          (item) =>
            item.subordinate_details.user_id ===
            current.subordinate_details.user_id
        );
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      filteredArr.sort((a, b) => {
        const bandA =
          a.subordinate_details.user_task_percentage_by_month.completedperc;
        const bandB =
          b.subordinate_details.user_task_percentage_by_month.completedperc;

        let comparison = 0;
        if (bandA > bandB) {
          comparison = -1;
        } else if (bandA < bandB) {
          comparison = 1;
        }
        return comparison;
      });
      setTopPerformerList(filteredArr);
    }
  }, [data]);

  return (
    <section className="topPerformerSec">
      <div className="secSubTitle">
        <div className="stLeft">
          <h5>
            Top 3 performers for{" "}
            {moment
              .tz(userTimeZone)
              .set({ month: moment().get("month") - 1 })
              .format("MMMM")}
          </h5>
        </div>
      </div>
      <div className="topPerformer_blk">
        <Card className="topPerformerCard">
          {loading || !data ? (
            <Loader />
          ) : topPerformerList.length === 0 ? (
            <Empty
              image={Empty_TopPerformer}
              description={`No top performers for ${moment
                .tz(userTimeZone)
                .set({ month: moment().get("month") - 1 })
                .format("MMMM")} `}
            />
          ) : (
            <Fragment>
              <div className="firstTopPerformer d-flex flex-column align-items-center">
                <UserAvatar
                  size="50"
                  firstName={topPerformerList[0].subordinate_details.first_name}
                  lastName={topPerformerList[0].subordinate_details.last_name}
                  src={
                    topPerformerList[0].subordinate_details.profile_image
                      ? REACT_APP_ASSETS_URL + topPerformerList[0].subordinate_details.profile_image
                      : undefined
                  }
                  count={Math.ceil(
                    topPerformerList[0].subordinate_details
                      .user_task_percentage_by_month.completedperc
                  )}
                  border
                  hideName
                />
                <div className="name">
                  {topPerformerList[0].subordinate_details.full_name}
                </div>
                <div className="location">
                  <CustIcon type="location" />{" "}
                  <span>
                    {topPerformerList[0].location_details.location_name}
                  </span>
                </div>
                <div className="status">
                  <Progress
                    percent={Math.ceil(
                      topPerformerList[0].subordinate_details
                        .user_task_percentage_by_month.completedperc
                    )}
                    status="active"
                  />
                </div>
              </div>
              {topPerformerList.length > 1 && (
                <ul className="list-inline topPerformerList">
                  {topPerformerList.map((singleUser, index) => {
                    if (index > 0)
                      return (
                        <li className="d-flex align-items-center justify-content-between myTopPerformer">
                          {/* <UserAvatar
                            title="Brett Shaw"
                            location="Burger king Hanover"
                            size="40"
                            src="https://i.pravatar.cc/80"
                            className="performerProfile"
                            border
                          /> */}
                          <UserAvatar
                            size="50"
                            className="performerProfile"
                            location={singleUser.location_details.location_name}
                            title={singleUser.subordinate_details.full_name}
                            firstName={
                              singleUser.subordinate_details.first_name
                            }
                            lastName={singleUser.subordinate_details.last_name}
                            src={
                              singleUser.subordinate_details.profile_image
                                ? REACT_APP_ASSETS_URL + singleUser.subordinate_details.profile_image
                                : undefined
                            }
                            count={index + 1}
                            border
                          />
                          <div className="performerPrograss">
                            <Progress
                              type="circle"
                              className="w-100"
                              width="100%"
                              percent={Math.ceil(
                                singleUser.subordinate_details
                                  .user_task_percentage_by_month.completedperc
                              )}
                            />
                          </div>
                        </li>
                      );
                  })}
                </ul>
              )}
            </Fragment>
          )}
        </Card>
      </div>
    </section>
  );
};
